import React from 'react';

function Testimonials() {
  const testimonials = [
    {
      quote:
        'The consultation was thorough and private. Sheryl understood exactly what I was hoping for and guided me to a solution that looks like me.',
      author: 'Sarah M.',
      detail: 'Custom hair system client',
    },
    {
      quote:
        'I finally feel confident walking out the door. The fit, cut-in, and blend were done with real care — nothing about it feels artificial.',
      author: 'Michael R.',
      detail: 'Hair replacement client',
    },
    {
      quote:
        'From the first visit through maintenance, the team made a sensitive process feel clear and respectful. I wish I had come sooner.',
      author: 'Jennifer L.',
      detail: 'Ongoing maintenance client',
    },
  ];

  return (
    <section className="bg-white py-24">
      <div className="container mx-auto px-4">
        <div className="mx-auto mb-14 max-w-3xl text-center">
          <p className="section-kicker">Client stories</p>
          <h2 className="section-heading mb-4">What people say after the first visit</h2>
          <p className="text-lg text-ink-muted">
            Real feedback from clients who came for information — and stayed for the result.
          </p>
        </div>

        <div className="grid gap-10 md:grid-cols-3">
          {testimonials.map((testimonial) => (
            <figure key={testimonial.author} className="border-t border-primary-200 pt-8">
              <blockquote className="font-display text-2xl font-medium leading-snug text-ink">
                “{testimonial.quote}”
              </blockquote>
              <figcaption className="mt-6">
                <p className="font-semibold text-ink">{testimonial.author}</p>
                <p className="text-sm text-ink-muted">{testimonial.detail}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
